var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import IsolationGroupsResourceInstance from "../../../../resources/expapiunified/IsolationGroups.unified.resource.js";
import { createUnifiedRestApi } from "../utils.js";
const builder = createUnifiedRestApi(
  IsolationGroupsResourceInstance,
  "isolation-groups",
  (state) => state.isolationGroups
);
const {
  actions: getTrafficUsageActions,
  selectAsyncRequest: selectTrafficUsageAsyncRequest,
  isOfType: isTrafficUsageAsyncRequestAction
} = builder.addMiscellaneousAction(
  "GET_TRAFFIC_USAGE_ASYNC",
  (payload) => __async(void 0, null, function* () {
    const { workspaceId, entity } = payload;
    return IsolationGroupsResourceInstance.getTrafficUsage(workspaceId, entity);
  })
);
const { load: getTrafficUsageAsync, reset: resetGetTrafficUsageAsync } = getTrafficUsageActions;
const { actions, epic, reducer, matchers, selectors, getDefaultReducerState } = builder.create();
const {
  selectQueryAsyncRequest: selectQueryIsolationGroupsAsyncRequest,
  selectAll: selectAllIsolationGroups,
  selectById: selectIsolationGroup
} = selectors;
const { queryAsync: queryIsolationGroupsAsync, getAsync: getIsolationGroup } = actions;
export {
  getDefaultReducerState as getDefaultIsolationGroupsReducerState,
  getIsolationGroup,
  getTrafficUsageAsync,
  isTrafficUsageAsyncRequestAction,
  epic as isolationGroupsEpic,
  matchers as isolationGroupsMatchers,
  reducer as isolationGroupsReducer,
  queryIsolationGroupsAsync,
  resetGetTrafficUsageAsync,
  selectAllIsolationGroups,
  selectIsolationGroup,
  selectQueryIsolationGroupsAsyncRequest,
  selectTrafficUsageAsyncRequest
};
//# sourceMappingURL=isolation-groups.js.map
